/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({ planId: ZodTypes.Id });

export const AdminPlanComputePatch = {
  id: 'admin-plan-compute.patch',
  tag: 'Admin',
  summary: 'Patch admin compute plan',
  description: 'Update a compute plan',
  method: 'patch',
  flags: { isAuthorized: true, isSuperuser: true },
  route: (params: z.infer<typeof Params>) => `/administration/plan/compute/${params.planId}`,
  request: {
    params: Params,
    body: {
      content: {
        'application/json': {
          schema: z.strictObject({
            name: z.string().min(1),
            isVisible: z.boolean(),
            isDefault: z.boolean(),
          }),
        },
      },
    },
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.string().optional(),
        },
      },
    },
  },
} as const satisfies Endpoint;
